// src/adapters/slackAdapter.js
import { integrationsRequest } from "../lib/integrations";
//
// Lightweight Slack adapter. Typical usage would query channel history
// and parse alerts. Here we provide a sample + a shape for real imports.

const SAMPLE = [
  {
    ts: "1725687600.000100",
    text: "ALERT: CPU 75% on staging nodes (autoscaler expected).",
    user: "ops-bot",
    channel: "ops-alerts",
  },
  {
    ts: "1725688600.000200",
    text: "CRASH: Android 14 camera crash spike detected (Crashlytics).",
    user: "mobile-bot",
    channel: "crash-alerts",
  },
];

export async function fetchSlackAlerts({
  channel,
  lookbackHours = 24,
  dryRun = false,
} = {}) {
  if (dryRun) {
    return SAMPLE.map(normalizeSlackMessage);
  }
  if (!channel) throw new Error("Choose a Slack channel to import from.");

  // Uses the signed-in user's own Slack connection (held by the integrations API).
  const data = await integrationsRequest("/slack/messages", { body: { channel, lookbackHours } });
  if (!Array.isArray(data.messages)) throw new Error("Slack returned an unexpected response.");
  return data.messages.map(m => normalizeSlackMessage({ ...m, channel: m.channel || channel }));
}

function normalizeSlackMessage(m) {
  const text = m.text || "";
  const impact =
    /outage|major|sev\s*1|sev-?1/i.test(text) ? 5 :
    /crash|error|failed|failure|sev\s*2|sev-?2/i.test(text) ? 4 :
    /warn|slow|degraded/i.test(text) ? 3 : 2;

  // Map impact to tier INTEGER (1=tier1, 2=tier2, 3=tier3)
  const tier = impact >= 4 ? 1 : impact === 3 ? 2 : 3;

  return {
    // Don't set id - let database auto-generate UUID
    ext_key: `slack:${m.ts}`,
    title: text.length > 80 ? `${text.slice(0, 77)}…` : text,
    summary: text,
    source: "Slack",
    tier,
    status: "new",
    owner: "",
    created_date: new Date().toISOString(),
    updated_date: new Date().toISOString(),
    tags: [m.channel || "alerts"],
    related_problem_id: "",
    impact,
  };
}
